import { Route, Navigate, Outlet } from 'react-router-dom';
import { ProtectedRoute } from 'ProtectedRoute';
import { SettingsComponent } from './components/SettingsComponent';

export const SETTINGS_ROUTES = {
    SETTINGS_SECTION: { path: '/settings/:section' },
};

export function configureSettingsRoutes() {
    return [
        {
            routes: SETTINGS_ROUTES,
            config: {},
        },
    ];
}

export function getSettingsRoutes() {
    return (
        <Route id="settings-routes" element={<Outlet />}>
            {/* Redirect routes */}
            <Route path="/register" element={<Navigate to="/settings/application" replace />} />
            <Route path="/settings/notifications" element={<Navigate to="/settings/preferences" replace />} />
            <Route path="/settings/network" element={<Navigate to="/settings/my-profile" replace />} />

            {/* Main settings routes */}
            <Route
                path={SETTINGS_ROUTES.SETTINGS_SECTION.path}
                element={
                    <ProtectedRoute accessPolicy="hasLearnerAccess" allowedWhenOnboardingIncomplete>
                        <SettingsComponent />
                    </ProtectedRoute>
                }
            />
            <Route path="/settings" element={<Navigate to="/settings/account" replace />} />
        </Route>
    );
}
